import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "../node_modules/bootstrap/dist/js/bootstrap.js";
import 'bootstrap/dist/css/bootstrap.min.css';
//  import "../node_modules/jquery/dist/jquery.slim.min.js";
//  import "../node_modules/popper.js/dist/popper.min.js";
//  import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
// Optional for JS functionality like modals or dropdowns
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// import "../node_modules/jquery/dist/jquery.min.js";
// import "../node_modules/jquery-ui/dist/jquery-ui.min.js";
// import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
